import React from "react";
import { List, Result, Typography } from "antd";
import { useLocation } from "react-router-dom";
import ComponentTransition from "../ComponentTransition/ComponentTransition";

const NetworkError: React.FC = () => {
  const location = useLocation();
  const authPaths = [
    "/sign-in",
    "/sign-up",
    "/forgot-password",
    "/reset-password",
  ];

  const isAuthPage = authPaths.includes(location.pathname);

  return (
    <ComponentTransition transitionType="fade" delay={0.5}>
      <div className="network-error">
        <div
          className={`network-error-content ${
            isAuthPage ? "height-auth" : "height-main"
          }`}
        >
          <div className="network-error-message">
            <Result
              status="warning"
              title="No Internet Connection"
              extra={
                <div>
                  <Typography.Text>Try:</Typography.Text>
                  <List
                    size="small"
                    bordered={false}
                    dataSource={[
                      "Checking your internet connection",
                      "Checking the network cables, modem and router",
                      "Reconnecting to Wi-Fi",
                    ]}
                    renderItem={(item) => <List.Item>{item}</List.Item>}
                  />
                  <Typography.Text>ERR_INTERNET_DISCONNECTED</Typography.Text>
                </div>
              }
            />
          </div>
        </div>
      </div>
    </ComponentTransition>
  );
};

export default NetworkError;
